<template>
  <div class="history">
    <el-header>
      <div class="page-title">{{ pageTitle }}</div>
    </el-header>
    <el-main>
      <div class="no-data" v-show="noData">
        <img src="~@/common/img/no_data.png" alt="">
        <span>没有找到相关内容</span>
      </div>
      <el-timeline>
        <el-timeline-item @click.native="goDetail(item)" :timestamp="item.view_time" placement="top" v-for="(item, index) in itemList" :key="index">
          <el-card>
            <img :src="item.thumbnail_path" alt="" :onerror="default_thumbnail_img">
            <div class="intro">
              <h3>{{item.name}}</h3>
              <p>{{item.owner_name}}</p>
            </div>
            <!-- 删除按钮 -->
            <div style="position: absolute;right: 60px">
              <el-button type="danger" icon="el-icon-delete" circle @click.stop='deleteHistory(item)'></el-button>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>

      <el-pagination v-show="!noData" background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" :total="total" layout="total, prev, pager, next">
      </el-pagination>

    </el-main>

  </div>
</template>

<script>
import Api from '@/api/user'

export default {
  name: 'History',
  data() {
    return {
      pageTitle: '浏览记录',
      currentPage: 1,
      pageSize: 3,
      total: 0,
      itemList: [],
      noData: false,
      default_thumbnail_img: 'this.src="' + require("@/common/img/default.png") + '"',
    }
  },
  created() {
    this.getHistoryList()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getHistoryList()
    },
    getHistoryList() {
      const data = {
        page: this.currentPage,
        page_size: this.pageSize
      }
      Api.getHistoryList(data).then(response => {
        if (response.data.status === 0) {
          this.currentPage = response.data.data.page
          this.pageSize = response.data.data.page_size
          this.total = response.data.data.total
          let list = response.data.data.list
          for (let i = 0; i < list.length; i++) {
            list[i].thumbnail_path = window.staticsHost + list[i].thumbnail_path;
          }
          this.itemList = list
          if (response.data.data.total === 0) {
            this.noData = true
          } else {
            this.noData = false
          }
        }
      })
    },
    deleteHistory(item) {
      // console.log(item);
      Api.deleteHistory(item.id.toString()).then(response => {
        if (response.data.status === 0) {
          this.getHistoryList();//刷新
        }
        else {
          console.log(response);
        }
      });
    },
    goDetail(item) {
      this.$router.push({
        path: '/micro/resource/resource_detail',
        query: {
          id: item.share_id
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.history {
  .el-header {
    height: 40px !important;
    padding: 0 5px;

    .page-title {
      font-size: 18px;
      text-align: left;
      border-left: 4px solid #559af8;
      color: #515151;
      padding-left: 10px;
    }
  }

  .el-main {
    padding: 10px 0 0;

    .no-data {
      width: 300px;
      height: 200px;
      margin: 100px auto;

      img {
        width: 300px;
      }

      span {
        font-size: 16px;
        color: #929292;
      }
    }

    .el-timeline {
      text-align: left;

      .el-card {
        cursor: pointer;

        /deep/ .el-card__body {
          text-align: left;
          display: flex;
          align-items: center;

          img {
            max-height: 100px;
          }

          .intro {
            padding: 0 20px;
          }
        }
      }
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 100px;
  }
}
</style>